import mqtt, { MqttClient } from 'mqtt'
import { mqttSettings } from './utils'

function getClient() {
  const client: MqttClient = mqtt.connect(mqttSettings.url, mqttSettings.options)
  client.stream.on('error', (err) => {
    console.log(`Connection to ${mqttSettings.url} failed`, err)
    client.end()
  })
  return client
}

function subscribe(client: MqttClient, topic: string) {
  return client.subscribe(topic, (err) => {
    if (err) {
      console.log('Subscription request failed', err)
    }
  })
}

function onMessage(client: MqttClient, callBack: (topic: string, message: string) => void) {
  client.on('message', (topic, message) => {
    //const msg = message.toString()
    callBack(topic, new TextDecoder('utf-8').decode(message))
  })
}

function publish(client: MqttClient, topic: string, message: string, retain: boolean) {
  client.publish(topic, message, { qos: 0, retain }, function (error) {
    if (error) {
      console.log(error)
    } else {
      console.log('Published')
    }
  })
}

function unsubscribe(client: MqttClient, topic: string) {
  client.unsubscribe(topic)
}

function closeConnection(client: MqttClient) {
  console.log('closeConnection')
  client.end()
}

const mqttService = {
  getClient,
  subscribe,
  onMessage,
  unsubscribe,
  closeConnection,
  publish,
}
export default mqttService
